export default __webpack_public_path__ + "static/new-roma-5-83485aa599b22c8c74624c15fa5eb5a6.jpg";